import {ApiVisa, BaseApiTemplateService, Core2Config} from "../../../shared";
import {AgentContainerModel} from "../../../../../../../models/aggregates/alg/cc/agent";
import {Injectable} from "@angular/core";
import {HttpClient, HttpHeaders} from "@angular/common/http";

@Injectable({providedIn: "root"})
export class AgentService extends BaseApiTemplateService<AgentContainerModel>{
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'agents';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'agents';
    this.httpClient = http;
  }

  async exportAgentCsvAsBlob(authorization: string, apiVisa: ApiVisa){
    const CSV_URL = this.apiUrl + '/export/csv';
    const headers = new HttpHeaders({ "authorization": authorization, "tenantCode" : apiVisa.tenantCode });
    const fileBlob = await this.httpClient
      .get(CSV_URL, { headers, responseType: 'blob' })
      .toPromise();
    return fileBlob;
  }
}
